import { Flower2, Heart, Laugh, Leaf, Moon, Sparkles, Zap } from "lucide-react";
import { SearchSelect } from "@/components/SearchSelect";
import { useLanguages } from "@/lib/languages";
import { INTENSITIES, PERSONALITIES } from "@/lib/config";

const ICONS = { Sparkles, Laugh, Heart, Flower2, Zap, Leaf, Moon };

export const LanguageSelect = ({ value, onChange, testId = "language-select", withAuto = true }) => {
  const langs = useLanguages(withAuto);
  return <SearchSelect testId={testId} value={value} onChange={onChange} options={langs} placeholder="Choose a language" searchPlaceholder="Search 100+ languages…" />;
};

export const IntensityPicker = ({ value, onChange, prefix = "intensity-pill" }) => {
  const active = INTENSITIES.find((x) => x.id === value);
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-5 gap-1.5 rounded-2xl bg-secondary/50 p-1.5">
        {INTENSITIES.map((x, i) => (
          <button key={x.id} data-testid={`${prefix}-${x.id}`} onClick={() => onChange(x.id)} title={x.desc}
            className={`relative rounded-xl py-2 text-[11px] sm:text-xs font-semibold transition-colors ${value === x.id ? `bg-gradient-to-br ${x.grad} text-white shadow` : "text-muted-foreground hover:text-foreground"}`}>
            <span className="block text-[10px] opacity-70">{i + 1}</span>{x.name}
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground" data-testid="intensity-description">{active?.desc}</p>
    </div>
  );
};

export const PersonalityPicker = ({ value, onChange, prefix = "personality-card" }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 gap-2">
    {PERSONALITIES.map((p) => {
      const Icon = ICONS[p.icon];
      const on = value === p.id;
      return (
        <button key={p.id} data-testid={`${prefix}-${p.id}`} onClick={() => onChange(p.id)}
          className={`flex items-center gap-2 rounded-xl border px-3 py-2.5 text-left text-xs font-medium transition-colors ${on ? "border-primary bg-primary/10 text-foreground" : "border-border hover:border-primary/40 text-muted-foreground"}`}>
          <Icon className={`h-4 w-4 shrink-0 ${on ? "text-accent" : ""}`} />{p.name}
        </button>
      );
    })}
  </div>
);

export const StyleControls = ({ language, setLanguage, intensity, setIntensity, personality, setPersonality }) => (
  <div className="panel p-5 sm:p-6 space-y-6" data-testid="style-controls">
    <div className="space-y-2">
      <div className="text-sm font-semibold">Language</div>
      <LanguageSelect value={language} onChange={setLanguage} />
    </div>
    <div className="space-y-2">
      <div className="text-sm font-semibold">Flirting intensity</div>
      <IntensityPicker value={intensity} onChange={setIntensity} />
    </div>
    <div className="space-y-2">
      <div className="text-sm font-semibold">Personality</div>
      <PersonalityPicker value={personality} onChange={setPersonality} />
    </div>
  </div>
);
